






























































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { dictServe, getArea, institutionServer, panoramicQueryServer, regionServe, spaceServe } from '@/api/installServer';
import { arrayToTree } from '@/util/array';
import publishObjectPath from '@/util/configRegistry';
import BusinessMapMarkers from '@/views/enterpriseSubjectInformation/businessManagement/unit/businessMapMarkers.vue';

@Component({
  components: { BusinessMapMarkers },
  filters: {
    ChangeType(type: string) {
      switch (type) {
        case 'add':
          return '新增';
        case 'edit':
          return '编辑';
        case 'detail':
          return '详情';
      }
    },
  },
})
export default class PublicPage extends Vue {
  @Prop(Object) row: any;
  @Prop(String) type: any;
  private canEdit = false; // 详情页不可编辑

  private companyTypeList: any = []; // 企业类型
  private companyIndustryList: any = []; // 企业-行业
  private jxIndustryList: any = []; // 九小-行业
  private competentUnitList: any = []; // 主管单位
  private creditLevelList: any = []; // 信用等级
  private industryTypeList: any = []; // 行业
  private areaBaseRiskLevelList: any = []; // 风险等级   安全风险等级

  formRules: any = {
    companyPlaceType: [{ required: true, message: '请选择企业场所类型', trigger: 'change' }],
    spaceId: [{ required: true, message: '请选择所属空间', trigger: 'change' }],
    streetDeptId: [{ required: true, message: '请选择所属街道', trigger: 'change' }],
    communityDeptId: [{ required: true, message: '请选择所属社区', trigger: 'change' }],
    supperAreaId: [{ required: true, message: '请选择上级区域', trigger: 'change' }],
    companyName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
    legalRepresentative: [{ required: true, message: '请输入法定代表人', trigger: 'blur' }],
    legalRepresentativePhone: [{ required: true, message: '请输入法定代表人联系方式', trigger: 'blur' }],
    socialCreditCode: [{ required: true, message: '请输入统一社会信用代码', trigger: 'blur' }],
    companyDirector: [{ required: true, message: '请输入负责人', trigger: 'blur' }],
    companyDirectorPhone: [{ required: true, message: '请输入负责人电话', trigger: 'blur' }],
    industry: [{ required: true, message: '请选择行业', trigger: 'blur' }],
    lng: [{ required: true, validator: this.pointRule, trigger: 'blur' }],
    // riskControl: [{ required: true, message: '请选择是否开展风险防控体系建设', trigger: 'blur' }],
    // riskLevel: [{ required: true, message: '请输入风险等级', trigger: 'blur' }],
    // securityRiskGrade: [{ required: true, message: '请输入安全风险分级', trigger: 'blur' }],
    // safetyDirector: [{ required: true, message: '请输入分管安全负责人', trigger: 'blur' }],
    // safetyDirectorPhone: [{ required: true, validator: this.phoneFenGuanRule, trigger: 'blur' }],
    // staffNumber: [{ required: true, message: '请输入职工人数', trigger: 'blur' }],
    // safeProduction: [{ required: true, message: '请选择是否签订安全生产责任状', trigger: 'blur' }],
    registeredAddress: [{ required: true, message: '请输入工商注册地址', trigger: 'blur' }],
    workSite: [{ required: true, message: '请输入生产场所', trigger: 'blur' }],
    detailAddress: [{ required: true, message: '请输入生产场所', trigger: 'blur' }],
    streetDirector: [{ required: true, message: '请输入街道联系人', trigger: 'blur' }],
    streetPhone: [{ required: true, message: '请输入街道电话', trigger: 'blur' }],
    communityDirector: [{ required: true, message: '请输入社区联系人', trigger: 'blur' }],
    communityPhone: [{ required: true, message: '请输入社区电话', trigger: 'blur' }],
  };

  private accidentRelateTypeList: any = [
    {
      value: '是',
      label: '是',
    },
    {
      value: '否',
      label: '否',
    },
  ];

  private formData: any = {
    companyPlaceType: '',
    spaceId: '',
    spaceCode: '',
    streetDeptId: '',
    streetName: '',
    communityDeptId: '',
    communityName: '',
    supperAreaId: '',
    companyName: '',
    legalRepresentative: '',
    legalRepresentativePhone: '',
    socialCreditCode: '',
    grid: '',
    gridPhone: '',
    companyDirector: '',
    companyDirectorPhone: '',
    companyType: '',
    territorial: '',
    competentUnit: '',
    inherentRiskFactor: '',
    industry: '',
    registeredAddress: '',
    workSite: '',
    detailAddress: '',
    streetDirector: '',
    streetPhone: '',
    communityDirector: '',
    communityPhone: '',

    businessRange: '',
    buildingInformation: '',
    firefightingEquipment: '',

    creditLevel: '',
    foundDate: '',
    id: '',
    lat: 0,
    lng: 0,
    riskControl: '',
    riskLevel: '',
    safeProduction: '',
    safetyDirector: '',
    safetyDirectorPhone: '',
    securityRiskGrade: '',
    staffNumber: 0,
  };
  private spaceList: any = [];
  private spaceTreeList: any = [];
  private streetList: any = [];
  private streetTreeList: any = [];
  private communityList: any = [];
  private communityListFilter: any = [];
  private supperAreaList: any = [];
  private supperAreaTreeList: any = [];

  private headers: any = {};
  private actionUrl: any = ''; // 图片上传
  private uploadUrl: any = ''; // 图片上传
  picList: any = [];
  private serverUrl = publishObjectPath.imgPathWater;

  placeTypeChange(e: any) {
    (this.$refs.form as any).clearValidate();
  }
  created() {
    this.getCompanyTypeOption('companyType'); // 企业类型
    this.getCompanyTypeOption('enterpriseType'); // 企业-行业
    this.getCompanyTypeOption('nineSmallPlacesType'); // 九小场所-行业
    this.getCompanyTypeOption('supervisingUnit'); // 主管单位
    this.getCreditLevelOption();
    this.getIndustryTypeOption();
    this.getAreaBaseRiskLevelOption();
    this.getSpaceListData();
    if (this.type === 'detail') {
      this.canEdit = true;
      this.getDetail(); // 详情
    }
    if (this.type === 'edit') {
      this.getDetail(); // 详情
    }
    if (this.type === 'add') {
      this.$nextTick(() => {
        (this.$refs['form'] as any).clearValidate();
      });
    }
  }
  private getSpaceListData() {
    spaceServe
      .getAllData({})
      .then((res: any) => {
        if (res.code === '200') {
          this.spaceList = res.data;
          this.spaceTreeList = arrayToTree(res.data);
        }
      })
      .catch(() => {
        this.$message.error('获取数据失败,请稍后重试!');
      });
  }
  spaceIdChange(e: any) {
    this.formData.spaceCode = '';
    this.formData.streetDeptId = '';
    this.formData.streetName = '';
    this.streetList = [];
    this.streetTreeList = [];
    this.formData.communityDeptId = '';
    this.formData.communityName = '';
    this.communityList = [];
    this.communityListFilter = [];
    this.formData.supperAreaId = '';
    this.supperAreaList = [];
    this.supperAreaTreeList = [];
    if (e) {
      this.formData.spaceCode = this.spaceList.find((item: any) => item.id === e).code;
      this.getPListData();
      this.getAreaListData();
    }
  }
  private getPListData() {
    institutionServer
      .getAllData({
        spaceId: this.formData.spaceId,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.communityList = res.data.filter((item: any) => item.type === '4');
          if (this.formData.streetDeptId) {
            this.communityListFilter = this.communityList.filter((item: any) => item.pid === this.formData.streetDeptId);
          }
          this.streetList = res.data.filter((item: any) => item.type === '1' || item.type === '2' || item.type === '3');
          this.streetTreeList = arrayToTree(this.streetList);
          this.streetTreeList.forEach((item: any, index: any) => {
            // 应急局下没有区域  删除
            if (!item.children || !item.children.length) {
              this.streetTreeList.splice(index, 1);
            } else {
              // 应急局下有区域, 区域下没有街道 删除
              item.children.forEach((elem: any, indexC: any) => {
                if (!elem.children || !elem.children.length) {
                  item.children.splice(indexC, 1);
                }
              });
            }
          });
        }
      })
      .catch(() => {
        this.$message.error('获取数据失败,请稍后重试!');
      });
  }
  streetChange(e: any) {
    this.formData.streetName = '';
    this.formData.communityDeptId = '';
    this.formData.communityName = '';
    this.communityListFilter = [];
    if (e) {
      this.formData.streetName = this.streetList.find((item: any) => item.id === e).name;
      this.communityListFilter = this.communityList.filter((item: any) => item.pid === e);
    }
  }
  communityChange(e: any) {
    this.formData.communityName = '';
    if (e) {
      this.formData.communityName = this.communityListFilter.find((item: any) => item.id === e).name;
    }
  }
  supperAreaIdChange(e: any) {
    // this.formData.communityName = '';
    // if (e) {
    //   this.formData.communityName = this.supperAreaList.find((item: any) => item.id === e).name;
    // }
  }

  private getAreaListData() {
    regionServe.getRegionAllData({ spaceId: this.formData.spaceId }).then((res: any) => {
      if (res.code === '200') {
        this.supperAreaList = res.data;
        this.supperAreaTreeList = arrayToTree(res.data);
      } else {
        this.$message.warning('获取区域的列表失败！');
      }
    });
  }

  mounted() {
    this.actionUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile/annex';
    this.uploadUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile';
    this.headers.Authorization = localStorage.getItem('token');
  }

  private handleSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.imgIds = arr.toString();
  }

  private handleRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.imgIds = arr.toString();
  }

  // 详情
  private getDetail() {
    panoramicQueryServer.getSinglePerformanceData({ id: this.row.id }).then((res: any) => {
      if (res.code === '200') {
        this.formData = res.data;
        if (res.data.imgList && res.data.imgList.length) {
          this.picList = res.data.imgList.map((item: any) => {
            return {
              url: this.serverUrl + item.path,
              id: item.id,
            };
          });
        }
      } else {
        this.$message.warning(res.msg);
      }
    });
  }

  private submitForm() {
    // console.log(this.formData);
    const formComponent: any = this.$refs['form'];
    formComponent.validate((valid: any) => {
      if (valid) {
        this.modifyRiskControlInventory();
      }
    });
  }

  // 编辑
  private modifyRiskControlInventory() {
    panoramicQueryServer
      .addOrEditInfoConfig({ ...this.formData })
      .then((res: any) => {
        if (res.code === '200') {
          if (this.type === 'add') {
            this.$message.success('数据新增成功！');
          } else {
            this.$message.success('数据编辑成功！');
          }
          this.close();
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {
        if (this.type === 'add') {
          this.$message.error('数据新增失败！');
        } else {
          this.$message.error('数据编辑失败！');
        }
      });
  }

  // 设置手机号的验证规则
  phoneRule(rule: any, value: any, callback: any) {
    if (!value) {
      callback(new Error('请输入联系电话'));
    } else {
      const reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
      // const phoneReg = /^1[34578]\d{9}$/
      if (reg.test(value)) {
        callback();
      } else {
        return callback(new Error('请输入正确的联系电话'));
      }
    }
  }
  pointRule(rule: any, value: any, callback: any) {
    if (!this.formData.lng) {
      callback(new Error('请选择位置'));
    } else {
      callback();
    }
  }

  // 设置手机号的验证规则
  phoneFenGuanRule(rule: any, value: any, callback: any) {
    if (!value) {
      callback(new Error('请输入分管安全负责人联系电话'));
    } else {
      const reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
      // const phoneReg = /^1[34578]\d{9}$/
      if (reg.test(value)) {
        callback();
      } else {
        return callback(new Error('请输入正确的分管安全负责人联系电话'));
      }
    }
  }

  /**
   @description: 打开地图弹框
   @author: cxf
   @update: cxf 2023/2/17 15:23
   **/
  private mapShow() {
    this.mapFuntion();
  }

  private mapFuntion() {
    const pointArr: any = [{ lng: this.formData.lng ? this.formData.lng : 104.101452, lat: this.formData.lat ? this.formData.lat : 30.659966 }];
    const mapDialog: any = 'mapDialog';
    const mapDialogRef: any = this.$refs[mapDialog];
    mapDialogRef.showDialog(pointArr, this.type);
  }

  private backData(data: any) {
    this.formData.lng = data[0] ? data[0].lng : 0;
    this.formData.lat = data[0] ? data[0].lat : 0;
    (this.$refs['form'] as any).validateField(['lng']);
  }

  // 获取企业类型
  private getCompanyTypeOption(name: any) {
    const dictTypeList: any = [];
    dictServe
      .getDetailsMapByName(name)
      .then((res: any) => {
        for (const key in res.data) {
          dictTypeList.push({
            // label: key,
            id: key,
            label: res.data[key],
            value: res.data[key],
          });
        }
        if (name === 'companyType') {
          this.companyTypeList = dictTypeList;
        } else if (name === 'enterpriseType') {
          this.companyIndustryList = dictTypeList;
        } else if (name === 'nineSmallPlacesType') {
          this.jxIndustryList = dictTypeList;
        } else {
          this.competentUnitList = dictTypeList;
        }
      })
      .catch((error: any) => {
        this.$message.warning('获取数据失败!');
      });
  }

  // 获取企业信用等级
  private getCreditLevelOption() {
    dictServe
      .getDetailsMapByName('creditLevel')
      .then((res: any) => {
        for (const key in res.data) {
          this.creditLevelList.push({
            // label: key,
            id: key,
            label: res.data[key],
            value: res.data[key],
          });
        }
      })
      .catch((error: any) => {
        this.$message.warning('获取企业信用等级数据失败!');
      });
  }

  // 获取行业
  private getIndustryTypeOption() {
    dictServe
      .getDetailsMapByName('industryType')
      .then((res: any) => {
        for (const key in res.data) {
          this.industryTypeList.push({
            // label: key,
            id: key,
            label: res.data[key],
            value: res.data[key],
          });
        }
      })
      .catch((error: any) => {
        this.$message.warning('获取行业数据失败!');
      });
  }

  // 获取风险等级   安全风险等级
  private getAreaBaseRiskLevelOption() {
    dictServe
      .getDetailsMapByName('areaBaseRiskLevel')
      .then((res: any) => {
        for (const key in res.data) {
          this.areaBaseRiskLevelList.push({
            // label: key,
            id: key,
            label: res.data[key],
            value: res.data[key],
          });
        }
      })
      .catch((error: any) => {
        this.$message.warning('获取风险等级数据失败!');
      });
  }

  private close() {
    this.$emit('close');
    this.canEdit = false;
  }
}
